export default {
  jobListingStatuses: [],
  jobListingStatus: undefined,
};
